import { IworkingHours } from "@/interfaces/Ibusiness";
import BusinessHoursSelector from "@/components/BusinessHoursSelector";
import { IProfile } from "@/interfaces/Iprofile";
import { useState, useEffect } from "react";

const WorkingHoursTab = ({
  profileData,
  isLoading,
  handleSave,
}: {
  profileData: IProfile;
  isLoading: boolean;
  handleSave: (workingHours: IworkingHours, timezone?: string) => Promise<void>;
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [workingHours, setWorkingHours] = useState<IworkingHours>({});

  useEffect(() => {
    if (profileData?.working_hours) {
      setWorkingHours(profileData.working_hours);
    }
  }, [profileData]);

  const handleWorkingHoursSave = async (
    newWorkingHours: IworkingHours,
    timezone: string
  ) => {
    try {
      setIsSaving(true);
      await handleSave(newWorkingHours, timezone);
      setWorkingHours(newWorkingHours);
    } catch (error) {
      console.error("Error saving working hours:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="space-y-4">
      <BusinessHoursSelector
        initialWorkingHours={workingHours}
        initialTimezone={profileData.timezone}
        onSave={handleWorkingHoursSave}
        isLoading={isLoading || isSaving}
      />
    </div>
  );
};

export default WorkingHoursTab;
